export default {"src":"/_next/static/media/new-build.46f36cd7.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};